export default __webpack_public_path__ + "static/media/bcbs239.3c22619d.svg";